import { IProps as ICardProps } from '@/components/Card/Card.interface';
import { IProps as IButtonProps } from '@/elements/Button/Button.interface';
import { IProps as IImageProps } from '@/elements/Image/Image.interface';

const mapAnchorProps = (
  button: any,
): IButtonProps & { 'data-eventname'?: string } => {
  const {
    link,
    variant,
    color,
    icon,
    iconPosition,
    iconDirection,
    ariaLabel,
    eventName,
    href,
    target,
    buttonText,
    btnStyle,
    colour,
    ...rest
  } = button || {};

  return {
    as: 'a',
    href: link?.href || href || undefined,
    target: link?.target || target || undefined,
    children: link?.text || button.text || buttonText || undefined,
    variant: btnStyle || 'primary',
    color: colour || color || undefined,
    icon: icon && icon.length > 0 ? icon : undefined,
    iconPosition:
      iconPosition && iconPosition?.length > 0 ? iconPosition : undefined,
    'aria-label': link?.ariaLabel || ariaLabel || undefined,
    'data-eventname': eventName || undefined,
    ...rest,
  };
};

const mapButtonProps = (button: any): IButtonProps => ({
  as: 'button',
  type: button.type || 'button',
  onClick: button.onClick,
  children: button.buttonText,
  variant: button.btnStyle || undefined,
  icon: button.icon || undefined,
  iconPosition: button.iconDirection || undefined,
  'aria-label': button.ariaLabel || undefined,
  disabled: button.disabled || undefined,
  tabIndex: button.tabIndex || undefined,
});

const mapImageProps = (image: any): IImageProps => ({
  alternateText: image.alternateText || undefined,
  defaultSrc: image.defaultSrc || undefined,
  sizesAttribute: image.sizesAttribute || undefined,
  srcSet: image.srcSet || undefined,
  loadingType: image.isLazy === true ? "lazy" : "eager",
});

const mapCardProps = (item: any): ICardProps => ({
  image: item.image ? mapImageProps(item.image) : undefined,
  title: item.heading || undefined,
  text: item.summary || undefined,
  contactInfoItems: item.contactInfo?.items?.map((item: any) => ({
    icon: item.icon,
    html: item.text
      ? item.text
      : item.link
        ? mapAnchorProps(item.link)
        : undefined,
  })),
  cta: item.button ? mapAnchorProps(item.button) : undefined,
  theme: item.backgroundTheme || undefined,
  date: item.date || undefined,
  categories: item.categories || undefined,
});

export { mapButtonProps, mapAnchorProps, mapImageProps, mapCardProps };
